export const translationsAdyen = {
  'pt-PT': {
    payButton: 'Guardar cartão',
  },
  'es-ES': {
    payButton: 'Guardar tarjeta',
  },
  'en-GB': {
    payButton: 'Save card',
  },

};

export const languageSelector = ( lang: string ) => {
  switch ( lang ) {
    case 'pt':
      return 'pt-PT';
    case 'es':
      return 'es-ES';
    case 'en':
      return 'en-GB';
    default:
      return 'en-GB';
  }
};
